import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'zef-select-category',
  templateUrl: './select-category.component.html',
  styleUrls: ['./select-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SelectCategory {
  @Input()
  category?: string;
}
